import { SearchBox } from '../ui'
import { Page } from './Page'
import styles from './SearchPage.module.css'

/** Full-width search for phones (the header search box is hidden below 1100px). */
export function SearchPage() {
  return (
    <Page title="Search" subtitle="Find a company by name or symbol, or search all filings">
      <div role="search" aria-label="Search stocks and filings" className={styles.box}><SearchBox /></div>
    </Page>
  )
}
